export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "mes", label: "Mês"},
        { key: "cnae", label: "CNAE"},
        { key: "numEmpregProp", label: "Número total de empregados próprios"},
        { key: "numDemisProp", label: "Número total de demissões próprios"},
        { key: "numAdmisProp", label: "Número total de admissões próprios"},
        { key: "numEmpregTerc", label: "Número total de empregados terceiros"},
        { key: "numDemisTerc", label: "Número total de demissões terceiros"},
        { key: "numAdmisTerc", label: "Número total de admissões terceiros"},
        { key: "createdAt", label: "Inserido"},
        { key: "updatedAt", label: "Atualizado"},
        
    ]
}